import UserTeamInvitationItem from './UserTeamInvitationItem';

export default UserTeamInvitationItem;
